import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { faLinkedin, faXing } from '@fortawesome/free-brands-svg-icons';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-platform-profile-social',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ReactiveFormsModule, TranslocoPipe, FaIconComponent],
  templateUrl: './platform-profile-social.component.html',
})
export class PlatformProfileSocialComponent {
  readonly form = input.required<FormGroup>();
  readonly submitAttempt = input(false);
  readonly icons = {
    linkedin: faLinkedin,
    xing: faXing,
  };
}
